import { useCallback } from "react";

import { useViewportDimension } from "./useViewportDimension";

export const useViewportWidth = <T extends number | boolean | string>(
  deriveFromWidth: (width: number) => T
): T => {
  const deriveFromDimension = useCallback(
    ({ width }: { width: number }) => deriveFromWidth(width),
    [deriveFromWidth]
  );

  return useViewportDimension<T>(deriveFromDimension);
};
